import { AppstoreOutlined, BarChartOutlined, BookOutlined, CalculatorOutlined, ControlOutlined, CreditCardOutlined, CustomerServiceOutlined, DatabaseOutlined, DollarOutlined, ExclamationCircleOutlined, FileTextOutlined, HomeOutlined, SafetyOutlined, TeamOutlined, UnorderedListOutlined, UserOutlined } from "@ant-design/icons";
import { LOGGED_USER } from "../variables/constants";

export const menuItems = [
    {
        key: "DASHBOARD",
        icon: <HomeOutlined style={{ fontSize: "18px" }} />,
        label: "Tableau de bord",
        link: "/#",
        right: ""
    },
    {
        key: "STATS",
        icon: <BarChartOutlined style={{ fontSize: "18px" }} />,
        label: "Statistiques",
        children: [
            { key: "stats-prod", label: "États Production", link: "/etats/production-globale" },
            { key: "stats-prod", label: "Stats Production", link: "/stats/agence-prod" },
            { key: "stats-sin", label: "Divers listing de sinistres", link: "/etats/sinistres" },
            { key: "stats-sin-sap", label: "SAP", link: "/stats/sap-sinistres" },
        ],
        right: "HET023"
    },
    {
        key: "CONSULTATION",
        icon: <BookOutlined style={{ fontSize: "18px" }} />,
        label: "Consultation",
        children: [
            { key: "consult-assures", label: "Assurés", link: "/assures", right: "HCL024" },
        ],
        right: ""
    },
    {
        type: "divider",
        section: "Module Production",
        right: "HLA025"
    },
    {
        key: "PRODUCTION",
        icon: <AppstoreOutlined style={{ fontSize: "18px" }} />,
        label: "Production",
        children: [
            { key: "prod-new", label: "Nouveau contrat", link: "/ajouter-contrat-new", right: "" },
            { key: "prod-all", label: "Tous les contrats", link: "/production", right: "HCO020" },
            { key: "prod-prop", label: "Propositions en cours", link: "/propositions", right: "HCO020" },
            { key: "prod-contrats", label: "Contrats en cours", link: "/contrats", right: "HCO020" },
            { key: "prod-printed", label: "Contrats imprimés", link: "/contrats-imprimes", right: "HCO020" },
            { key: "prod-not-printed", label: "Non-imprimés", link: "/contrats-non-imprimes", right: "HCO020" },
            { key: "prod-comm", label: "Commissions générées", link: "/commissions-generees", right: "" },
            { key: "prod-bord", label: "Bordereaux", link: "/bordereaux", right: "" },
        ],
        right: "HCO020"
    },
    {
        key: "ATTESTATION",
        icon: <UnorderedListOutlined style={{ fontSize: "18px" }} />,
        label: "Attestations",
        children: [
            { key: "att-all", label: "Toutes les attestations", link: `${LOGGED_USER?.profil?.organisme?.typeOrganisme === "POOL" ? "/gestion-des-attestations" : LOGGED_USER?.profil?.organisme?.typeOrganisme === "SIEGE" ? "/mes-attestations" : '/mes-attestations'}`, right: "" },
            {
                key: "att-cmd", label: "Commandes", link: `${LOGGED_USER?.profil?.organisme?.typeOrganisme === "POOL" ? "/compagnies-commandes" : LOGGED_USER?.profil?.organisme?.typeOrganisme === "SIEGE"
                    ? "/nos-commandes" : "/commandes"}`, right: ""
            },
        ],
        right: "HCO069"
    },
    {
        key: "CAISSE",
        icon: <DollarOutlined style={{ fontSize: "18px" }} />,
        label: "Caisse",
        children: [
            { key: "caisse-attente", label: "Encais. en cours", link: "/en-attente-d-encaissement", right: "HCO008" },
            { key: "caisse-enc", label: "Encaissements", link: "/encaissements", right: "HCO008" },
            { key: "caisse-mobile", label: "Encaissement Mobile", link: "/transactions-mobile-money", right: "HCO008" },
            { key: "caisse-revers", label: "Reversement de primes", link: "/versements-en-compagnie", right: "HCO008" },
            { key: "caisse-bord", label: "Bordereaux", link: "/borderaux-de-versement-en-compagnie", right: "HCO008" },
        ],
        right: "HCO008"
    },
    // {
    //     key: "COMPTABILITE",
    //     icon: <CreditCardOutlined style={{ fontSize: "18px" }} />,
    //     label: "Comptabilité",
    //     children: [
    //         { key: "compta-comptes", label: "Comptes", link: "/comptabilite/comptes", right: "HLA029" },
    //         { key: "compta-livre", label: "Grand Livre", link: "/comptabilite/grand-livre", right: "HLA029" },
    //         { key: "compta-balance", label: "Balance", link: "/comptabilite/balance", right: "HLA029" },
    //         { key: "compta-param", label: "Paramétrage", link: "/comptabilite/parametrage", right: "HLA029" },
    //     ],
    //     right: "HLA029"
    // },
    {
        type: "divider",
        section: "Module Sinistres",
        right: "HSI027"
    },
    {
        key: "SINISTRES",
        icon: <ExclamationCircleOutlined style={{ fontSize: "18px" }} />,
        label: "Dossiers sinistres",
        children: [
            { key: "sin-decl", label: "Déclaration de sinistres", link: "/declarer-sinister", right: "" },
            { key: "sin-list", label: "Liste des sinistres", link: "/liste-des-sinistres", right: "HSI027" },
            { key: "sin-eval", label: "Évaluations", link: "/validation-evaluation", right: "" },
            { key: "sin-paid", label: "Paiements sinistres", link: "/validation-decaissement", right: "" },
        ],
        right: "HSI027"
    },
    {
        type: "divider",
        section: "MODULE COMPTABILITé",
        right: "HLA029"
    },
    {
        key: "COMPTABILITE",
        icon: <CreditCardOutlined style={{ fontSize: "18px" }} />,
        label: "Comptabilité",
        children: [
            { key: "compta-comptes", label: "Comptes", link: "/comptabilite/comptes", right: "HLA029" },
            { key: "compta-livre", label: "Ecritures comptables", link: "/comptabilite/grand-livre", right: "HLA029" },
            { key: "compta-balance", label: "Balance", link: "/comptabilite/balance", right: "HLA029" },
        ],
        right: "HLA029"
    },
    {
        key: "OPERATIONS",
        icon: <CalculatorOutlined style={{ fontSize: "18px" }} />,
        label: "Opérations",
        children: [
            { key: "op-cession", label: "Cession", link: "/toutes-les-cessions", right: "" },
            { key: "op-retro", label: "Rétrocession", link: "/retrocessions", right: "" },
            { key: "op-retro-vt", label: "Rétrocession VT", link: "/retrocession-vt/arretes", right: "" },
            { key: "op-versements-vt", label: "Versements VT", link: "/retrocession-vt/versements", right: "" },
        ],
        right: "HOP028"
    },
    {
        type: "divider",
        section: "Module Paramètres",
        right: ""
    },
    {
        key: "MEMBRES",
        icon: <TeamOutlined style={{ fontSize: "18px" }} />,
        label: "Organismes",
        link: "/membres",
        right: "HME030"
    },
    {
        key: "PARAMETRES",
        icon: <ControlOutlined style={{ fontSize: "18px" }} />,
        label: "Paramètres",
        children: [
            { key: "param-tarif", label: "Tarification", link: "/tarification", right: "HPA031" },
            { key: "param-sin", label: "Paramètres sinistres", link: "/parametres/sinistres", right: "" },
            { key: "param-compta", label: "Paramètres Comptabilité", link: "/comptabilite/parametrage", right: "HLA029" },
            { key: "param-autres", label: "Autres paramètres", link: "/autres-parametres", right: "HPA032" },
            { key: "param-ma-compagnie", label: "Ma compagnie", link: "/ma-compagnie", right: "" },
            { key: "param-agences", label: "Mes Agences", link: "/ma-compagnie?tab=agences", right: "" },
        ],
        right: "HPA032"
    },
    {
        type: "divider",
        section: "Module des Droits & Accès",
        right: "HPE033"
    },
    {
        key: "UTILISATEURS",
        icon: <UserOutlined style={{ fontSize: "18px" }} />,
        label: "Utilisateurs",
        link: "/utilisateurs",
        right: "HPE033"
    },
    {
        key: "PROFILS",
        icon: <SafetyOutlined style={{ fontSize: "18px" }} />,
        label: "Profils",
        link: "/profils",
        right: "HAC034"
    },
    {
        key: "DROITS",
        icon: <ControlOutlined style={{ fontSize: "18px" }} />,
        label: "Droits",
        children: [
            { key: "droits-hab", label: "Habilitations", link: "/habilitations", right: "" },
            { key: "droits-mod", label: "Modules", link: "/modules", right: "" },
            { key: "droits-routes", label: "Routes", link: "/routes", right: "" },
        ],
        right: "HAC035"
    },
    {
        type: "divider",
        section: "Reprise de données",
        right: "HPA032"
    },
    {
        key: "REPRISE",
        icon: <DatabaseOutlined style={{ fontSize: "18px" }} />,
        label: "Reprise",
        children: [
            { key: "reprise-polices", label: "Polices compagnies", link: "/migration/reprise/polices-eforce", right: "HPA032" },
            { key: "reprise-sinistres-decl", label: "Sinistres déclarés", link: "/migration/reprise/sinistres-declarations", right: "HPA032" },
            { key: "reprise-sinistres-payes", label: "Sinistres payés", link: "/migration/reprise/sinistres-payes", right: "HPA032" },
            { key: "reprise-gumvt", label: "Sinistres GUM / VT", link: "/migration/reprise/gumvt", right: "HPA032" },
            { key: "reprise-gumvt-regl", label: "GUM/VT — Compléter règlements", link: "/migration/reprise/gumvt-reglements", right: "HPA032" },
            { key: "reprise-gumvt-commiss", label: "GUM/VT — Compléter commissariats", link: "/migration/reprise/gumvt-commissariats", right: "HPA032" },
            { key: "reprise-gumvt-sap", label: "GUM/VT — Corriger SAP & évaluations", link: "/migration/reprise/gumvt-sap-evaluations", right: "HPA032" },
            { key: "reprise-gumvt-honoraires", label: "GUM/VT — Corriger honoraires", link: "/migration/reprise/gumvt-honoraires", right: "HPA032" },
            { key: "reprise-gumvt-eval-courante", label: "Compagnies — Recaler évaluation & SAP", link: "/migration/reprise/gumvt-evaluation-courante", right: "HPA032" },
            { key: "reprise-gumvt-dates", label: "GUM/VT — Corriger dates règlements", link: "/migration/reprise/gumvt-dates", right: "HPA032" },
            { key: "reprise-sinistres-fusion", label: "Sinistres — Fusionner doublons", link: "/migration/reprise/sinistres-fusion-doublons", right: "HPA032" },
        ],
        right: "HPA032"
    },
    {
        key: "SUPPORT",
        icon: <CustomerServiceOutlined style={{ fontSize: "18px" }} />,
        label: "Support",
        link: "https://ossanasur.com/support",
    },
    {
        key: "DOCUMENTATION",
        icon: <FileTextOutlined style={{ fontSize: "18px" }} />,
        label: "Documentation",
        link: "https://ossanasur.com/poolins/documentation/",
    },
];
